import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { DefaultLabel } from "@assets/label";
import { OutlinedInputDefault } from "@assets/TextField";
import { useInput } from "@assets/hooks";
import { maxLength } from "@assets/validators";
import images from "@app/images";
import { DefaultContainedButton, DefaultOutlinedButton } from "@assets/buttons";
import { passRule } from "@assets/utils/check";
import { useAccount } from "@redux/account";
// import { useBackdrop } from "@assets/hooks";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 630,
  height: "auto",
  overflow: "scroll",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: { xl: 4, lg: 4, md: 4, sm: 4, xs: 2 },
  pt: 6,
};

const AdvertiserDialog = ({
  open,
  target,
  onClose,
  onNewRows,
  onListUpdate,
  onNewRowsFilter,
}) => {
  const nullEmail = target.email === null ? "" : target.email;
  const account = useAccount();
  const title = useInput(target.name, maxLength); // 광고명
  const email = useInput(nullEmail); // 광고명
  const password = useInput("", maxLength);
  const [pwMode, setPwMode] = useState(false);
  const handleUpdate = () => {
    if (
      title.value === "" ||
      title.value === undefined ||
      title.value === null
    ) {
      alert("광고주 이름을 확인해주세요");
      return false;
    }
    if (
      email.value === "" ||
      email.value === undefined ||
      email.value === null
    ) {
      alert("광고주 이메일을 확인해주세요");
      return false;
    }
    if (!passRule.test(email.value)) {
      //경고
      alert("광고주 이메일을 확인해주세요");
      return false;
    }
    const totalData = {
      email: email.value,
      user_id: target.user_id,
    };
    account.update(totalData, (data, response) => {
      if (response.status === 200) {
        if (data.error) {
          alert(data.error.message);
        } else {
          alert("수정완료 되었습니다.");
          onListUpdate(target, email.value);
        }
      } else {
        if (!response.data || !response.data.error) {
          alert("에러가 발생하였습니다.");
        } else {
          alert(response.data.error.message);
        }
      }
    });
  };
  // const handlePWUpdate = () => {
  //   if (target.email === null) {
  //     alert("담당 이메일을 설정후 이용해주세요.");
  //     return false;
  //   }
  //   const totalData = {
  //     email: target.email,
  //   };
  //   account.reset(totalData, (data, response) => {
  //     if (response.status === 200) {
  //       if (data.error) {
  //         alert(data.error.message);
  //       } else {
  //         if (data.result) {
  //           alert("이메일 전송 완료 되었습니다.");
  //         } else {
  //           alert("이메일 전송에 실패하였습니다.");
  //         }
  //       }
  //     } else {
  //       if (!response.data || !response.data.error) {
  //         alert("에러가 발생하였습니다.");
  //       } else {
  //         alert(response.data.error.message);
  //       }
  //     }
  //   });
  // };

  /** 비밀번호 변경 모드 */
  const handleChangeForm = () => {
    setPwMode((prev) => !prev);
    password.onReset(); // password reset
  };
  const handleNewPw = () => {
    if (
      password.value === "" ||
      password.value === undefined ||
      password.value === null
    ) {
      alert("비밀번호를 확인해주세요.");
    } else {
      const totalData = {
        npw: password.value,
        email: nullEmail,
      };
      account.pwChange(totalData, (data, response) => {
        if (response.status === 200) {
          if (data.result) {
            alert("비밀번호 변경이 완료되었습니다.");
          } else {
            alert("비밀번호 변경을 실패하였습니다. 다시 시도해주세요.");
          }
          onClose();
        } else {
          if (!response.data || !response.data.error) {
            alert("에러가 발생하였습니다.");
          } else {
            alert(response.data.error.message);
          }
          onClose();
        }
      });
    }
  };
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container justifyContent="center">
            <Typography
              variant="h2"
              sx={{ color: "#424242" }}
              fontWeight={500}
              align="center"
            >
              광고주 정보
            </Typography>
          </Grid>
          <Grid container sx={{ pt: 5, pb: 5.625 }} direction="column">
            <Grid
              container
              direction="column"
              sx={{
                pt: 4.375,
                pb: 4.375,
                pr: 10.375,
                pl: 10.375,
              }}
            >
              <DefaultLabel name="광고주 이름" />
              <OutlinedInputDefault
                value={title.value}
                disabled={true}
                onChange={title.onChange}
                name={"title"}
                krName={"광고주 이름"}
              />
              <Box sx={{ mt: 2.5 }}></Box>
              {!pwMode ? (
                <>
                  <DefaultLabel name="담당 이메일" />
                  <OutlinedInputDefault
                    value={email.value}
                    onChange={email.onChange}
                    name={"banner_name"}
                    krName={"담당 이메일"}
                  />
                </>
              ) : (
                <>
                  <DefaultLabel name="담당 이메일" />
                  <OutlinedInputDefault
                    value={nullEmail}
                    onChange={() => {
                      alert("변경불가합니다.");
                    }}
                    name={"banner_name"}
                    krName={"담당 이메일"}
                    disabled={true}
                  />
                </>
              )}
              {pwMode && (
                <>
                  <Box sx={{ mt: 2.5 }}></Box>
                  <DefaultLabel name="비밀번호" />
                  <OutlinedInputDefault
                    inputType="password"
                    value={password.value}
                    onChange={password.onChange}
                    name={"banner_password"}
                    krName={"광고주_비밀번호"}
                  />
                </>
              )}
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                onClick={handleChangeForm}
                sx={{
                  mt: 1,
                  cursor: "pointer",
                  "&:hover": {
                    "& >div": {
                      color: "grey.800",
                    },
                    "& >img": {
                      content: `url('${images.arrow_up_on.default}')`,
                    },
                  },
                }}
              >
                <Typography
                  variant="body2"
                  component="div"
                  fontWeight={500}
                  color="#9A9A9B"
                >
                  광고주 {!pwMode ? "비밀번호" : "이메일"} 변경
                </Typography>
                <img src={images.arrow_up_off.default} alt="메일전송" />
              </Grid>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ mt: 6 }}
              >
                <Grid sx={{ width: "50%", pr: 1 }}>
                  <DefaultOutlinedButton
                    variant="outlined"
                    borderColor="primary.main"
                    color="primary"
                    fullWidth
                    sx={{ mt: 5 }}
                    text="취소"
                    onClick={onClose}
                  />
                </Grid>
                <Grid sx={{ width: "50%", pl: 1 }}>
                  <DefaultContainedButton
                    color="primary"
                    fullWidth={true}
                    height={56}
                    borderColor="primary.main"
                    fontWeight={500}
                    text={!pwMode ? "수정완료" : "비밀번호 수정완료"}
                    onClick={!pwMode ? handleUpdate : handleNewPw}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {/* <DefaultBackdrop open={backdrop.value} /> */}
    </>
  );
};

export default AdvertiserDialog;
